<template>
  <div class="text-center">
    <v-dialog v-model="show" max-width="300px">
      <v-card>
        <v-card-title>Download</v-card-title>

        <v-card-text>
          <p>Du kannst die aktuellen Kalender herunterladen und importieren.</p>

          <v-list nav>
            <v-list-item>
              <v-btn color="primary" href="/probe" download block> Proben </v-btn>
            </v-list-item>
            <v-list-item>
              <v-btn color="primary" href="/orga" download block> Orga </v-btn>
            </v-list-item>
            <v-list-item>
              <v-btn color="primary" href="/schauspiel" download block> Schauspiel </v-btn>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="show = false"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>  